




 <div
 class="modal_fade"
 id="exampleModal"
 tabindex="-1"
 aria-labelledby="exampleModalLabel"
 aria-hidden="true"
 
 >
 <div class="modal-dialog"  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"></h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body" >
        <div class="status-info text-center" >
          <img src="assets/img/info.svg" width="50" 
          alt="info" *ngIf="title =='Updating Installer Status'"/>
          
          <h5 class="text-white pt-3">{{ message }}</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-light btn-sm proceed-button"
          data-bs-dismiss="modal"
          (click)="accept()">
          {{ btnOkText }}
        </button>

        <button
          type="button"
          class="btn btn-outline-light btn-sm cancel-button "
          
          data-bs-dismiss="modal"
          (click)="decline()">
          {{ btnCancelText }}
        </button>

      </div>
    </div>
  </div>
</div>

